import React, { useState } from 'react'
import { Box, Hidden, withStyles } from '@material-ui/core'
import { Menu } from '@material-ui/icons'
import classNames from 'classnames'

import SidebarMenu from './SidebarMenu'

const MobileSidebarMenu = ({
  userType,
  userCategory,
  appBarHeight,
  classes,
}) => {
  const [open, setOpen] = useState(false)
  const toggleMenu = () => setOpen(!open)
  const menuClass = classNames({ [classes.open]: open }, classes.menu)

  return (
    <Hidden mdUp>
      <Box>
        <Menu onClick={toggleMenu} style={{ cursor: 'pointer' }} />
        <SidebarMenu
          userType={userType}
          userCategory={userCategory}
          side="right"
          open={open}
          className={menuClass}
          style={{ top: appBarHeight }}
        />
      </Box>
    </Hidden>
  )
}

const styles = theme => ({
  menu: {
    right: 0,
    position: 'fixed',
    transform: 'translateX(100%)',
  },
  open: {
    [theme.breakpoints.down('sm')]: {
      transform: 'translateX(0)',
    },
  },
})

export default withStyles(styles)(MobileSidebarMenu)
